import './FooterLegend.css';
const FooterLegend = ({title, subtitle}) => {
   return (
      <div className='footerLegend-div'>
         <h2 className='footerLegend-legend'>{title}</h2>
         <h3 className='footerLegend-secondLegend'>{subtitle}</h3>
      </div>
   )
}
export default FooterLegend